import { addMonths } from 'date-fns';
import { Falcon } from 'modules/macro';
import { IconButton } from 'modules/v2/navigation/buttons';
import { useCalendar } from '../../Context';
import { LayoutHelperButton } from '../../styled';
export function PreviousMonthButton() {
    const { timeZone, locale, focusedDate, setFocusedDate, yearPickerVisible } = useCalendar();
    const previousMonth = addMonths(focusedDate, -1);
    const handleClick = () => setFocusedDate(previousMonth);
    const ariaFormat = new window.Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: 'long',
        timeZone,
    });
    if (yearPickerVisible) {
        return (<LayoutHelperButton>
        <Falcon icon="chevron-left"/>
      </LayoutHelperButton>);
    }
    return (<IconButton type="button" appearance="ghost" size="xs" aria-label={ariaFormat.format(previousMonth)} onClick={handleClick}>
      <Falcon icon="chevron-left"/>
    </IconButton>);
}
